import validate from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/middleware/auth.global.ts";
import permission_45global from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/middleware/permission.global.ts";
import track_45user_45global from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/middleware/trackUser.global.ts";
import manifest_45route_45rule from "D:/NavaService/vcan/ipbx_hosted_dashboard_spike/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  permission_45global,
  track_45user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "job-edit": () => import("D:/NavaService/vcan/ipbx_hosted_dashboard_spike/middleware/jobEdit.ts")
}